import { useRef } from 'react';
import Logo from './Logo';

const SaveLogo = () => {
  const containerRef = useRef<HTMLDivElement>(null);

  const handleDownload = () => {
    if (containerRef.current) {
      const svg = containerRef.current.querySelector('svg');
      if (svg) {
        const canvas = document.createElement('canvas');
        const ctx = canvas.getContext('2d');
        const size = 256; // Larger size for better quality
        
        canvas.width = size;
        canvas.height = size;
        
        // Convert SVG to data URL
        const data = new XMLSerializer().serializeToString(svg);
        const svgBlob = new Blob([data], { type: 'image/svg+xml;charset=utf-8' });
        const url = URL.createObjectURL(svgBlob);
        
        const img = new Image();
        img.onload = () => {
          if (ctx) {
            ctx.fillStyle = 'white';
            ctx.fillRect(0, 0, size, size);
            ctx.drawImage(img, 0, 0, size, size);
            
            // Create download link
            const link = document.createElement('a');
            link.download = 'pedigreepro-logo.jpg';
            link.href = canvas.toDataURL('image/jpeg', 0.9);
            link.click();
            
            URL.revokeObjectURL(url);
          }
        };
        img.src = url;
      }
    }
  };

  return (
    <div className="min-h-screen bg-neutral-50 flex items-center justify-center p-4">
      <div className="bg-white p-8 rounded-xl shadow-lg text-center">
        <div ref={containerRef} className="mb-6">
          <Logo size={256} />
        </div>
        <button 
          onClick={handleDownload}
          className="btn bg-primary text-white hover:bg-primary-dark"
        >
          Download Logo as JPG
        </button>
      </div>
    </div>
  );
};

export default SaveLogo;